var _defs, _path, _path2, _polygon, _path3, _path4, _path5, _path6, _path7, _path8, _rect, _path9, _rect2, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _line, _path18, _rect3, _rect4, _text, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgObj50(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1548.6 264.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#50bd86;}.cls-2{fill:#434341;}.cls-3,.cls-7{fill:#fff;}.cls-4{fill:#ffdc00;}.cls-5{fill:#9164cd;}.cls-6{fill:#aae2c2;}.cls-7{font-size:45px;font-family:CloserText-Black, Closer Text;font-weight:800;letter-spacing:0.05em;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M746,247.18A92.22,92.22,0,1,0,653.71,155,92.25,92.25,0,0,0,746,247.18Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M746,249a94,94,0,1,1,94.1-94A94.17,94.17,0,0,1,746,249Zm0-184.44A90.4,90.4,0,1,0,836.44,155,90.53,90.53,0,0,0,746,64.56Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "847.66 79.49 824.27 77.92 822.35 54.19 855.95 20.59 857.69 44.15 881.25 45.9 847.66 79.49"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M848.36,81.36l-25.78-1.73L820.47,53.5l37-37,1.92,26,26,1.93ZM826,76.21l21,1.41,30.2-30.2L856,45.85l-1.57-21.16L824.23,54.88Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M746,228a73,73,0,1,0-73-73A73,73,0,0,0,746,228Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M746,205.84A50.88,50.88,0,1,0,695.08,155,50.89,50.89,0,0,0,746,205.84Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M746,207.66A52.7,52.7,0,1,1,798.71,155,52.77,52.77,0,0,1,746,207.66Zm0-101.75A49.06,49.06,0,1,0,795.07,155,49.12,49.12,0,0,0,746,105.91Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M746,180.46A25.5,25.5,0,1,0,720.47,155,25.51,25.51,0,0,0,746,180.46Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M746,182.28A27.32,27.32,0,1,1,773.32,155,27.36,27.36,0,0,1,746,182.28Zm0-51A23.68,23.68,0,1,0,769.68,155,23.72,23.72,0,0,0,746,131.28Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 647.94,
    y: 83.24,
    width: 171.04,
    height: 33.97,
    rx: 4.85,
    transform: "translate(-5.33 147.03) rotate(-11.41)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M657.58,134.56a7.72,7.72,0,0,1-7.54-6.18l-4.39-21.77a7.72,7.72,0,0,1,6-9.07L807.81,66a7.72,7.72,0,0,1,9.07,6l4.39,21.78a7.69,7.69,0,0,1-6,9.06L659.11,134.41A7.93,7.93,0,0,1,657.58,134.56Zm151.75-65a4.34,4.34,0,0,0-.8.08l-156.14,31.5a4.07,4.07,0,0,0-3.17,4.78l4.39,21.77a4.08,4.08,0,0,0,4.78,3.18l156.14-31.5a4.06,4.06,0,0,0,3.17-4.78l-4.39-21.78a4.08,4.08,0,0,0-4-3.25Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 649.83,
    y: 92.92,
    width: 167.49,
    height: 14.56,
    transform: "translate(-5.33 147.05) rotate(-11.41)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M511.53,174l-38.77,7.9a1.54,1.54,0,0,0-1.27,1.27l-6.24,38.64a1.53,1.53,0,0,1-3,.08l-8.19-38.26a1.51,1.51,0,0,0-1.23-1.18L416,174.07a1.53,1.53,0,0,1-.1-3l36.31-7a1.5,1.5,0,0,0,1.12-1.12l9-36.73a1.53,1.53,0,0,1,3,.06l7.28,36.07a1.52,1.52,0,0,0,1.13,1.18l38,7.44A1.53,1.53,0,0,1,511.53,174Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M362.12,66.88l-19.74,4a.76.76,0,0,0-.65.65l-3.18,19.67a.78.78,0,0,1-1.53,0l-4.17-19.48a.78.78,0,0,0-.63-.6l-18.76-4.26a.78.78,0,0,1,0-1.53l18.49-3.56a.75.75,0,0,0,.57-.57l4.58-18.71a.79.79,0,0,1,1.53,0L342.28,61a.8.8,0,0,0,.58.61l19.33,3.78A.78.78,0,0,1,362.12,66.88Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1281.54,56l-27.72,5.66a1.08,1.08,0,0,0-.91.91l-4.47,27.63a1.09,1.09,0,0,1-2.15.05l-5.85-27.35a1.08,1.08,0,0,0-.88-.85l-26.34-6a1.09,1.09,0,0,1-.07-2.14l26-5a1.11,1.11,0,0,0,.8-.81l6.43-26.26a1.09,1.09,0,0,1,2.13,0l5.21,25.79a1.09,1.09,0,0,0,.81.85l27.13,5.32A1.09,1.09,0,0,1,1281.54,56Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1017.78,234.31l-14.47,2.95a.57.57,0,0,0-.47.48l-2.33,14.41a.57.57,0,0,1-1.12,0l-3.06-14.27a.57.57,0,0,0-.46-.44l-13.74-3.12a.57.57,0,0,1,0-1.12l13.55-2.61a.56.56,0,0,0,.42-.42l3.35-13.7a.57.57,0,0,1,1.12,0l2.71,13.46a.58.58,0,0,0,.43.44l14.15,2.77A.57.57,0,0,1,1017.78,234.31Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M171.78,179.31l-14.47,2.95a.57.57,0,0,0-.47.48l-2.33,14.41a.57.57,0,0,1-1.12,0l-3.06-14.27a.57.57,0,0,0-.46-.44l-13.74-3.12a.57.57,0,0,1,0-1.12l13.55-2.61a.56.56,0,0,0,.42-.42l3.35-13.7a.57.57,0,0,1,1.12,0L157.24,175a.58.58,0,0,0,.43.44l14.15,2.77A.57.57,0,0,1,171.78,179.31Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1473.78,120.31l-14.47,3a.57.57,0,0,0-.47.48l-2.33,14.41a.57.57,0,0,1-1.12,0l-3.06-14.27a.57.57,0,0,0-.46-.44l-13.74-3.12a.57.57,0,0,1,0-1.12l13.55-2.61a.56.56,0,0,0,.42-.42l3.35-13.7a.57.57,0,0,1,1.12,0l2.71,13.46a.58.58,0,0,0,.43.44l14.15,2.77A.57.57,0,0,1,1473.78,120.31Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1072.11,47.89l-17.17,3.51a.68.68,0,0,0-.57.56l-2.76,17.12a.68.68,0,0,1-1.34,0l-3.62-17a.68.68,0,0,0-.55-.52l-16.32-3.71a.67.67,0,0,1,0-1.32l16.09-3.1a.67.67,0,0,0,.49-.5l4-16.27a.68.68,0,0,1,1.32,0l3.22,16a.69.69,0,0,0,.51.52l16.81,3.29A.68.68,0,0,1,1072.11,47.89Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M574.74,55.4l-17,3.47a.67.67,0,0,0-.56.56l-2.74,17a.67.67,0,0,1-1.32,0l-3.59-16.8a.67.67,0,0,0-.55-.52l-16.17-3.68a.67.67,0,0,1,0-1.31l15.94-3.07a.65.65,0,0,0,.49-.49l4-16.13a.67.67,0,0,1,1.31,0l3.2,15.83a.65.65,0,0,0,.5.52l16.66,3.27A.67.67,0,0,1,574.74,55.4Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 746.57,
    y1: 154.43,
    x2: 856.96,
    y2: 44.05
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M746.57,156.25a1.78,1.78,0,0,1-1.28-.53,1.82,1.82,0,0,1,0-2.57L855.67,42.76a1.82,1.82,0,1,1,2.58,2.57L747.86,155.72A1.8,1.8,0,0,1,746.57,156.25Z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 877.35,
    y: 156.31,
    width: 257,
    height: 34,
    rx: 17
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 886.35,
    y: 161.81,
    width: 134,
    height: 23,
    rx: 11.5
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(1156.17 187.26)"
  }, "50%")), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M881.59,114.69a13.31,13.31,0,0,1,18.23,0,13.62,13.62,0,0,1,0,18.41,13.31,13.31,0,0,1-18.23,0,13.65,13.65,0,0,1,0-18.41Zm5.3,13.53a5.13,5.13,0,0,0,7.61,0,6.95,6.95,0,0,0,0-8.65,5.11,5.11,0,0,0-7.61,0,7,7,0,0,0,0,8.65Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M919.25,111.64a10.59,10.59,0,0,1,6.68,2,6.19,6.19,0,0,1,2.56,5.13,6.71,6.71,0,0,1-2,4.76,6.6,6.6,0,0,1,2.66,5.35,6.38,6.38,0,0,1-2.61,5.26,10.79,10.79,0,0,1-6.81,2H907.31v-24.5Zm-4.55,6.2v3h4.48a2.13,2.13,0,0,0,1.4-.43,1.35,1.35,0,0,0,.52-1.07,1.29,1.29,0,0,0-.52-1,2.18,2.18,0,0,0-1.4-.42Zm0,8.78v3.29h5a2.28,2.28,0,0,0,1.49-.45,1.52,1.52,0,0,0,.54-1.23,1.43,1.43,0,0,0-.56-1.13,2.2,2.2,0,0,0-1.47-.48Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M930.9,129.35a6.83,6.83,0,0,0,2.84.56q3.46,0,3.46-3.36V111.64h7.42v16.07a8.47,8.47,0,0,1-2.69,6.51,10,10,0,0,1-7,2.49,7,7,0,0,1-4-.81Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M949.21,111.64h18.9v6.2H956.59v2.9h9.91v6h-9.91v3.15h11.87v6.23H949.21Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M986.1,117.84v18.3h-7.39v-18.3h-7.38v-6.2h22.15v6.2Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M997,111.64h7.38v24.5H997Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1007.59,111.64h8l5.39,15,5.28-15h8l-10,24.5h-6.62Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1038.88,114.69a13.31,13.31,0,0,1,18.23,0,13.65,13.65,0,0,1,0,18.41,13.31,13.31,0,0,1-18.23,0,13.65,13.65,0,0,1,0-18.41Zm5.3,13.53a5.13,5.13,0,0,0,7.61,0,6.95,6.95,0,0,0,0-8.65,5.11,5.11,0,0,0-7.61,0,7,7,0,0,0,0,8.65Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgObj50);
export default __webpack_public_path__ + "static/media/Obj_50.45606b39bfdea7126db5ffb8f599405d.svg";
export { ForwardRef as ReactComponent };